// extracted by mini-css-extract-plugin
export default {"root":"BiographyPersonGrid-module--root--88426","profile":"BiographyPersonGrid-module--profile--94a8e","bio":"BiographyPersonGrid-module--bio--964f0"};